import styled from "styled-components";
import vimg from "../images/Vector.png";
import icon1 from "../images/power-button.png";
import icon2 from "../images/pack.png";
import icon7 from "../images/clerk.png";
import icon3 from "../images/delivery.png";
import icon4 from "../images/receive.png";
import icon5 from "../images/unboxing.png";
import icon6 from "../images/icons/disable.png";
import icon9 from "../images/icons/verify-package.png";
import { Link, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import useAuth from "../hooks/useAuth";
import { LuBadgeHelp } from "react-icons/lu";
import Select from "react-select";
import { useA2HS } from "react-use-a2hs";
import {
	useGetAllClients,
	useGetAllClientsForTP,
	useGetClientLocations,
	useSwitchContextTradingPartner,
} from "../migration-api/api-hooks/client";
import { PERMISSIONS, ROLES } from "../utils/Permissionutils";

export const Container = styled.div`
	padding: 2rem 0;
	height: 94dvh;
	overflow-y: auto;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}
	@media screen and (min-width: 481px) {
		padding: 2rem;
		border-radius: 16px;
		margin: 1rem 0;
		box-shadow: 0 0 22px 1px #e2e2e2dd;
	}
`;
const Top = styled.div`
	display: flex;
	justify-content: space-around;
`;
const SpanLeft = styled.span`
	height: 30px;
	width: 30px;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #fff3f3;
	cursor: pointer;
`;
const SpanRight = styled.span`
	font-style: Regular;
	font-size: 15px;
	line-height: 30px;
	line-height: 165%;
	color: #000000;
	flex: 80%;
	flex-grow: 0;
	text-align: center;
`;
const Tabs = styled.div`
	width: 92%;
	margin: auto;
	margin-top: 50px;
`;
const Tab = styled.div`
	height: 99px;
	border-radius: 10px;
	padding: 25px, 16px, 25px, 16px;
	border: 1px solid #dee1ff;
	margin: 20px 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	opacity: ${(props) => (props.disabled ? 0.5 : 1)};
	pointer-events: ${(props) => (props.disabled ? "none" : "all")};
	cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;
const TabLeft = styled.span`
	flex: 20%;
	padding: 20px;
	flex-grow: 0;
	display: flex;
	justify-content: center;
	align-items: center;
`;
const TabRight = styled.span`
	flex: 80%;
	flex-grow: 0;
`;

const TabRightHeader = styled.span`
	font-weight: 600;
	font-size: 18px;
	line-height: 17px;
`;

const Icon = styled.div`
	width: 50px;
	height: 50px;
`;

const AlertMessage = styled.div`
	background-color: #fff3cd;
	border: 1px solid #ffc107;
	color: #856404;
	padding: 12px 16px;
	border-radius: 8px;
	margin: 20px auto;
	width: 92%;
	text-align: center;
	font-size: 14px;
`;

const PromptWrapper = styled.div`
	position: relative;
	height: 100%;
	width: 100%;
`;
const ButtonContainer = styled.div`
	position: absolute;
	bottom: 10px;
	width: 100%;
`;

const StyleButton = styled.button`
	height: 50px !important;
	background-color: rgb(33, 33, 33) !important;
	width: 100%;
	color: white !important;
	border: 0;
	border-radius: 10px;
	cursor: pointer;
`;
const PromptContainer = styled.div`
	width: 200px;
	height: 120px;
	position: absolute;
	bottom: 10px;
	right: 0;
	padding: 10px;
`;

// Dashboard action configurations
const DASHBOARD_ACTIONS = [
	{
		key: "commissioning",
		path: "/pages/commissioning",
		permission: PERMISSIONS.CREATE_COMMISSION,
		icon: icon1,
		title: "Commission Labels",
	},
	{
		key: "packing",
		path: "/pages/packing",
		permission: PERMISSIONS.PACK_LABEL,
		icon: icon2,
		title: "Pack Products",
	},
	{
		key: "shipping",
		path: "/pages/shipping",
		permission: PERMISSIONS.SHIP_LABEL,
		icon: icon3,
		title: "Ship Package",
	},
	{
		key: "receiving",
		path: "/pages/receiving",
		permission: PERMISSIONS.RECEIVE_LABEL,
		icon: icon4,
		title: "Receive Package",
	},
	{
		key: "unpacking",
		path: "/pages/unpacking",
		permission: PERMISSIONS.UNPACK_LABEL,
		icon: icon5,
		title: "Unpack Package",
	},
	{
		key: "dispense",
		path: "/pages/dispense",
		permission: PERMISSIONS.DISPENSE_LABEL,
		icon: icon7,
		title: "Dispense Package",
	},
	{
		key: "decommissioning",
		path: "/pages/decommissioning",
		permission: PERMISSIONS.CREATE_DECOMMISSION,
		icon: icon6,
		title: "Decommission Labels",
	},
	{
		key: "packages",
		path: "/pages/packages",
		permission: PERMISSIONS.VIEW_PACKING,
		icon: icon2,
		title: "View Packages",
	},
	{
		key: "verifyPack",
		path: "/pages/verify-pack",
		permission: PERMISSIONS.VIEW_PACKING,
		icon: icon9,
		title: "Verify Package",
	},
];

/**
 * @param {{
 *     accessToken: string,
 *     refreshToken: string,
 *     providerToken: string | null,
 *     user: {
 *       id: number,
 *       firstName: string,
 *       lastName: string,
 *       email: string,
 *       role: string,
 *       clientId: number,
 *       clientKey: string | null,
 *       location: string | null,
 *       userClients: unknown[] | null,
 *       permissions: string[]
 *       locations:
 *          {
 *            id: number,
 *            clientKey: string,
 *            gln: string,
 *            clientName: string,
 *            address: string,
 *            latitude: number,
 *            longitude: number,
 *            createdAt: string,
 *            updatedAt: string | null,
 *          }[] | null
 *       userProducts:
 *          {
 *            id: number,
 *            clientKey: string,
 *            clientName: string,
 *            gtin: string,
 *            prodName: string,
 *            productName: string,
 *            descriptions: string,
 *            mandateNo: string,
 *            isMandate: boolean,
 *            createdAt: string,
 *            updatedAt: string | null,
 *          }[] | null
 *     }
 * }} auth //this is the auth data structure from the AuthContext
 */

function Dashboard() {
	const {
		auth,
		updateClientId,
		updateUserObj,
		updateClientLocation,
		updateClientEmail,
	} = useAuth();

	const userRole = auth?.user?.role;
	const isSuperAdmin = userRole === ROLES.SUPER_ADMIN;
	const isTradingPartner = userRole === ROLES.TRADING_PARTNER;
	const isMobileUser = userRole === ROLES.INFORMER_MOBILE;
	const requiresClientSelection = isSuperAdmin || isTradingPartner;
	const userLocations = auth?.user?.locations || []; //for regular users login
	const userGLN = auth?.user?.location || ""; //for trading partners gln directly from the login response

	const [selectedClientId, setSelectedClientId] = useState(null);
	const [selectedClientGLN, setSelectedClientGLN] = useState(null);
	const navigate = useNavigate();
	const { setCloseLogoutFormMobile } = useContext(AuthContext);

	// Fetch clients based on role
	const { data: superAdminClients, isLoading: loadingSuperAdminClients } =
		useGetAllClients({}, { enabled: isSuperAdmin });

	const { data: tradingPartnerClients, isLoading: loadingTPClients } =
		useGetAllClientsForTP({}, { enabled: isTradingPartner });

	const { data: clientLocations, isLoading: loadingClientLocations } =
		useGetClientLocations(selectedClientId, {
			enabled: Boolean(selectedClientId && isSuperAdmin),
		});

	//TASK: why is there a whole endpoint for switching trade partner client Id?
	const { mutate: switchContext, isLoading: isSwitchingContext } =
		useSwitchContextTradingPartner({
			onSuccess: (response) => {
				// Extract the updated user object from the API response
				// Adjust the path based on your actual API response structure
				const updatedUser = response?.data?.user || response?.user;

				if (updatedUser) {
					// Update the entire user object in the auth context
					// This should include updated permissions, clientId, etc.
					updateUserObj(updatedUser);

					// Update local state with the new client ID
					setSelectedClientId(updatedUser.clientId);
				} else {
					console.warn(
						"No user object found in switch context response",
					);
				}
			},
			onError: (error) => {
				console.error("Failed to switch context:", error);

				// Optionally show an error message to the user
				// You might want to use a toast/notification library here
				alert("Failed to switch client. Please try again.");
			},
		});

	// Determine which clients list to use
	const allClients = isSuperAdmin
		? superAdminClients?.data
		: isTradingPartner
			? tradingPartnerClients?.data
			: null;

	const isLoadingClients = loadingTPClients || loadingSuperAdminClients;

	const [promptEvent, promptToInstall] = useA2HS();
	const [hidePrompt, setHidePrompt] = useState(true);

	// Check if action is allowed
	const isActionAllowed =
		(isMobileUser || (requiresClientSelection && selectedClientId)) &&
		selectedClientGLN;

	const handleClientChange = (selectedOption) => {
		if (!selectedOption) {
			setSelectedClientId(null);
			updateClientId(null);
			return;
		}

		const newClientId = selectedOption.value;
		const clientGln = allClients?.find(
			(eachClient) => eachClient.id === selectedOption.value,
		)?.location;

		const tradingPartnerEmail = allClients?.find(
			(eachClient) => eachClient.id === selectedOption.value,
		)?.email;

		if (isTradingPartner) {
			// For trading partners, call the switch context API
			// This will update the entire user object via the onSuccess callback
			// switchContext(newClientId);
			setSelectedClientId(newClientId);
			updateClientEmail(tradingPartnerEmail);
			updateClientLocation(userGLN);
			setSelectedClientGLN(userGLN);
		} else if (isSuperAdmin) {
			// For super admin, just update the client ID locally
			// Super admins don't need to call the API for context switching
			setSelectedClientId(newClientId);
			updateClientId(newClientId);
			updateClientLocation(clientGln);
		}
	};

	const handleNavigation = (path, permission) => {
		if (!isActionAllowed) {
			return;
		}
		navigate(path);
	};

	const handleLocationChange = (selectedOption) => {
		if (!selectedOption) {
			setSelectedClientId(null);
			updateClientId(null);
			return;
		}

		const clientGLN = selectedOption.value;
		updateClientLocation(clientGLN);
		setSelectedClientGLN(clientGLN);
	};

	return (
		<Container>
			<Top>
				<SpanLeft onClick={() => setCloseLogoutFormMobile(true)}>
					<img src={vimg} alt="" />
				</SpanLeft>
				<SpanRight>{auth?.user?.email}</SpanRight>
			</Top>

			<Link
				to={"/pages/guide"}
				style={{
					fontSize: "18px",
					display: "flex",
					gap: "6px",
					alignItems: "center",
					color: "#6D0000",
					textDecoration: "none",
					paddingLeft: "10px",
					marginTop: "28px",
				}}
			>
				<LuBadgeHelp size={28} color="" />
				App Guide
			</Link>

			{/* Client Selection for SUPER_ADMIN and TRADING_PARTNER */}
			{requiresClientSelection && (
				<div style={{ width: "92%", margin: "18px auto 0" }}>
					<Select
						styles={{
							control: (style) => ({
								...style,
								border: "1px solid #d6d6d6",
								width: "100%",
								height: "40px",
								fontSize: "14px",
							}),
						}}
						theme={(theme) => ({
							...theme,
							borderRadius: "7px",
							colors: {
								...theme.colors,
								primary25: "#f8f8f8",
								primary: "#e3dbdb",
							},
						})}
						placeholder={
							isLoadingClients
								? "Loading clients..."
								: isSwitchingContext
									? "Switching client..."
									: "Select a client to continue"
						}
						isLoading={isLoadingClients || isSwitchingContext}
						isDisabled={isLoadingClients || isSwitchingContext}
						value={
							selectedClientId && allClients
								? {
										value: selectedClientId,
										label:
											allClients.find(
												(c) =>
													c.id === selectedClientId,
											)?.clientName ||
											allClients.find(
												(c) =>
													c.id === selectedClientId,
											)?.email ||
											"Unknown Client",
									}
								: null
						}
						onChange={handleClientChange}
						options={
							allClients?.map((client) => ({
								value: client.id,
								label: client.clientName || client.email,
							})) || []
						}
						isClearable
					/>
				</div>
			)}

			{/* Alert message when client selection is required */}
			{requiresClientSelection && !selectedClientId && (
				<AlertMessage>
					Please select a client above to enable actions
				</AlertMessage>
			)}

			{/* Client location Selection for SUPER_ADMIN */}
			{selectedClientId && isSuperAdmin && (
				<div style={{ width: "92%", margin: "18px auto 0" }}>
					<Select
						styles={{
							control: (style) => ({
								...style,
								border: "1px solid #d6d6d6",
								width: "100%",
								height: "40px",
								fontSize: "14px",
							}),
						}}
						theme={(theme) => ({
							...theme,
							borderRadius: "7px",
							colors: {
								...theme.colors,
								primary25: "#f8f8f8",
								primary: "#e3dbdb",
							},
						})}
						placeholder={
							isLoadingClients
								? "Loading locations..."
								: "Select a location to continue"
						}
						isLoading={loadingClientLocations}
						isDisabled={loadingClientLocations}
						value={
							selectedClientId && clientLocations
								? {
										value: selectedClientGLN,
										label:
											clientLocations.data?.find(
												(c) =>
													c.gln === selectedClientGLN,
											)?.address || "Select Location",
									}
								: null
						}
						onChange={handleLocationChange}
						options={
							clientLocations?.data?.map((client) => ({
								value: client.gln,
								label:
									client.address ||
									client.gln ||
									"Unknown Location",
							})) || []
						}
						isClearable
					/>
				</div>
			)}

			{/* Alert message when client location selection is required */}
			{selectedClientId && !selectedClientGLN && (
				<AlertMessage>
					Please select a client location above to enable actions
				</AlertMessage>
			)}

			{/* Mobile only user location Selection*/}
			{isMobileUser && (
				<div style={{ width: "92%", margin: "18px auto 0" }}>
					<Select
						styles={{
							control: (style) => ({
								...style,
								border: "1px solid #d6d6d6",
								width: "100%",
								height: "40px",
								fontSize: "14px",
							}),
						}}
						theme={(theme) => ({
							...theme,
							borderRadius: "7px",
							colors: {
								...theme.colors,
								primary25: "#f8f8f8",
								primary: "#e3dbdb",
							},
						})}
						placeholder={"Select a location to continue"}
						isLoading={false}
						isDisabled={false}
						value={{
							value: selectedClientGLN,
							label:
								userLocations?.find(
									(c) => c.gln === selectedClientGLN,
								)?.address || "Select Location",
						}}
						onChange={handleLocationChange}
						options={
							userLocations?.map((location) => ({
								value: location.gln,
								label:
									location.address ||
									location.gln ||
									"Unknown Location",
							})) || []
						}
						isClearable
					/>
				</div>
			)}

			{/* Alert message when client location selection is required */}
			{isMobileUser && (
				<AlertMessage>
					Please select a client location above to enable actions
				</AlertMessage>
			)}

			<Tabs>
				{DASHBOARD_ACTIONS.map((action) => (
					<Tab
						key={action.key}
						onClick={() =>
							handleNavigation(action.path, action.permission)
						}
						disabled={!isActionAllowed}
					>
						<TabLeft>
							<Icon>
								<img src={action.icon} width={"100%"} alt="" />
							</Icon>
						</TabLeft>
						<TabRight>
							<TabRightHeader>{action.title}</TabRightHeader>
						</TabRight>
					</Tab>
				))}
			</Tabs>

			{promptEvent && hidePrompt && (
				<PromptContainer>
					<PromptWrapper>
						<ButtonContainer>
							<StyleButton
								onClick={() => {
									promptToInstall();
									setHidePrompt(false);
								}}
							>
								Add to Home screen
							</StyleButton>
						</ButtonContainer>
					</PromptWrapper>
				</PromptContainer>
			)}
		</Container>
	);
}

export default Dashboard;
